import { diContainer } from '../DIContainer';
import { AppStorageKey } from '../types';
import { I18n } from './I18n';
import Money from '../utilities/Money';
import ApiService from '../services/ApiService';
import Store from './Store';
import Settings from './Settings';
import Axios from 'axios';
import { getReseller } from '../branding';
const Locale = {
    async detect() {
        // try locale / primary store
        let locale = await this.get();
        if (locale)
            return locale;
        // try native store
        const appStorage = diContainer.resolve('appStorage');
        locale = await appStorage.native().getItem(AppStorageKey.locale, null);
        if (locale)
            return locale;
        // try geolocating
        const location = await this.detectLocation();
        if (location?.country_code_iso3 === 'MNE')
            return 'me';
        if (location?.country_code_iso3 === 'SRB')
            return 'sr';
        if (location?.country_code_iso3 === 'BIH')
            return 'ba';
        return 'en';
    },
    async detectLocation() {
        try {
            const ipResponse = await Axios.get('https://api.ipify.org?format=json');
            if (!ipResponse.data.ip)
                return undefined;
            const response = await Axios.get(`https://ipapi.co/${ipResponse.data.ip}/json/`);
            if (response.data.error)
                return undefined;
            return response.data;
        }
        catch (error) {
            console.error('Detect Location Failed: ' + error.message);
            return undefined;
        }
    },
    async get() {
        const appStorage = diContainer.resolve('appStorage');
        return appStorage.local().getItem(AppStorageKey.locale, null);
    },
    async set(locale) {
        const appStorage = diContainer.resolve('appStorage');
        await appStorage.local().setItem(AppStorageKey.locale, locale, null);
        await appStorage.native().setItem(AppStorageKey.locale, locale, null);
        Store.set('locale', locale);
        ApiService.init(locale);
        // Set language if not set
        let language = await this.getLanguage();
        if (!language) {
            language = I18n.c('general.language', locale) || 'en';
        }
        await this.setLanguage(language);
        // Set currency if not set
        let currency = await this.getCurrency();
        if (!currency) {
            currency = I18n.c('general.currency', locale) || 'USD';
            await this.setCurrency(currency);
        }
        Settings.onLocaleChange(locale);
    },
    async getLanguage() {
        const appStorage = diContainer.resolve('appStorage');
        return appStorage.local().getItem(AppStorageKey.language, null);
    },
    async setLanguage(language) {
        const appStorage = diContainer.resolve('appStorage');
        await appStorage.local().setItem(AppStorageKey.language, language, null);
        I18n.setLocale(language);
        const device = diContainer.resolve('device');
        if (device.isElectron()) {
            await Settings.electron.invoke('i18nSetLocale', language);
        }
    },
    async getCurrency() {
        const appStorage = diContainer.resolve('appStorage');
        return appStorage.local().getItem(AppStorageKey.currency, null);
    },
    async setCurrency(currency) {
        const appStorage = diContainer.resolve('appStorage');
        await appStorage.local().setItem(AppStorageKey.currency, currency, null);
        Money.setCurrency(currency);
    },
    async getApiUrl(locale) {
        if (!locale)
            locale = await this.get() || undefined;
        return Settings.env[`API_URL_${locale?.toUpperCase()}`] || Settings.env['API_URL'] || Settings.env['API_URL_SR'];
    },
    getAdminDomain() {
        const url = Settings.env['WEB_URL'];
        // For dev or staging, add '.admin' after the environment prefix
        if (url.includes('dev.') || url.includes('staging.')) {
            return url.replace(/(https?:\/\/)?(dev\.|staging\.)/, '$1$2admin.');
        }
        // For other environments, add 'admin.' after protocol
        return url.replace(/(https?:\/\/)/, '$1admin.');
    },
    getLogoUrl(variant = 'light', shape = 'vertical') {
        // Vertical lockup by default: the squarish shape the auth-screen slots were
        // sized for, matching the reseller full logos. Horizontal suits short, wide
        // slots (admin sidebar header).
        return `/branding/konty/logo-full-${shape}-${variant}.svg`;
    },
    getBrand() {
        // Fall back to `lastTenant` so the pre-tenant-login screens (TenantLogin,
        // TenantRegister) are fully branded — logo and color theme — by the last
        // logged-in tenant's reseller, alongside every post-login screen using
        // the active tenant.
        const tenant = Store.get('tenant') || Store.get('lastTenant');
        if (!tenant)
            return null;
        return getReseller(tenant.reseller?.name);
    },
    getBrandedLogoUrl(variant = 'light', shape = 'vertical') {
        const brand = this.getBrand();
        return brand ? brand.logo[variant] : this.getLogoUrl(variant, shape);
    }
};
export default Locale;
export { Locale };
//# sourceMappingURL=Locale.js.map